import React, { useEffect } from "react";
import Dashboard from "./dashboard/dashboard";
import useInitializeDashboard from "./hooks/useInitializeDashboard";
import CustomLoader from "./components/ReusableComponents/CustomLoader/CustomLoader";
import LaunchBar from "./components/LaunchBar/launchbar";
import "./App.css"; // Import the custom CSS
import { RESPONSE_STATUS } from "./utils/constants";
import RetryComponent from "./components/RetryComponent/RetryComponent";
import NoWidgetsConfigured from "./components/NoWidgetsConfigured/NoWidgetsConfigured";
import analytics from "./utils/analytics";
import { getUserDetails } from "./utils/authUtils";

const App = () => {
  const {
    layout,
    dashboards,
    activeDashboard,
    cssLoad,
    setActiveDashboard,
    smartviewsConfig,
    initialize,
  } = useInitializeDashboard();

  useEffect(() => {
    if (process.env.NODE_ENV === "production") {
      analytics.init();
      analytics.setUser(getUserDetails());
    }
  }, []);

  let content;
  if (
    dashboards.responseStatus === RESPONSE_STATUS.requestPending ||
    smartviewsConfig.responseStatus === RESPONSE_STATUS.requestPending ||
    cssLoad.responseStatus === RESPONSE_STATUS.requestPending
  )
    content = <CustomLoader />;
  else if (
    dashboards.responseStatus === RESPONSE_STATUS.requestRejected ||
    smartviewsConfig.responseStatus === RESPONSE_STATUS.requestRejected ||
    cssLoad.responseStatus === RESPONSE_STATUS.requestRejected
  )
    content = <RetryComponent onRetry={initialize} />;
  else if (dashboards.response.length === 0) content = <NoWidgetsConfigured />;
  else
    content = (
      <Dashboard
        layoutJSON={layout}
        coverPageData={activeDashboard?.layout?.coverPage}
        dashboards={dashboards.response}
        activeDashboard={activeDashboard}
        setActiveDashboard={setActiveDashboard}
        smartviewsConfig={smartviewsConfig.response}
      />
    );

  return (
    <div
      className="casa-web-dashboard-body custom-app-container"
      style={{ width: "100%", height: "100%" }}
    >
      {content}
      <LaunchBar />
    </div>
  );
};

export default App;
